
import { Vue, Component } from 'vue-property-decorator';

import {
  HelperViewContextual,
  HelperViewStatus
} from '@warrenbrasil/nebraska-web';

import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';
import { FeatureFlags } from '@/types/models/FeatureFlags';

@Component({
  components: {
    HelperViewContextual,
    HelperViewStatus
  }
})
export default class PlatformMaintenance extends Vue {
  private created() {
    if (!this.isPlatformMaintenance && !this.isUnifiedAccountMaintenance)
      this.redirectToOverview();
  }

  get isPlatformMaintenance() {
    return FeatureFlagsModule.isEnabled(FeatureFlags.PLATFORM_MAINTENANCE);
  }

  get isUnifiedAccountMaintenance() {
    return FeatureFlagsModule.isEnabled(
      FeatureFlags.UNIFIED_ACCOUNT_MAINTENANCE
    );
  }

  get helperViewData() {
    return {
      title: 'Plataforma em manutenção',
      status: 'alert',
      description:
        'Estamos passando por uma manutenção na nossa plataforma, mas não se preocupe, logo estaremos de volta.'
    };
  }

  get unifiedAccountHelperData() {
    return {
      icon: 'EE0160',
      title: 'Uma nova funcionalidade está sendo adicionada a sua conta',
      context: 'brand',
      description:
        'Sua conta está em uma rápida manutenção para adição de uma nova funcionalidade. Pedimos desculpas por quaisquer inconvenientes causados.'
    };
  }

  redirectToOverview() {
    window.location.href = '/app/#/v3';
  }
}
